import { render, staticRenderFns } from "./CSV.vue?vue&type=template&id=4f38caf8&scoped=true&"
import script from "./CSV.vue?vue&type=script&lang=js&"
export * from "./CSV.vue?vue&type=script&lang=js&"
import style0 from "./CSV.vue?vue&type=style&index=0&id=4f38caf8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f38caf8",
  null
  
)

export default component.exports